// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import {changeOwed} from "../../WorkIssuanceOwed/owedSlice";
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function ApproveOwed({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    const handleApprove = () => {
        dispatchData(changeOwed({approvedState: true, owedNewStatus: 'Approved'}));
        dispatchData(changeWorkIssuance({newStatus:  '2039', updateCdpStatus: true}));
        onMenuClose();
    };





    return (

        <Box>
            {(
                    (  rowCdpStatus === "2339" ||  rowCdpStatus === "2040" ||  rowCdpStatus === "3706" ||  rowCdpStatus === "m"
                ) && showOwed === true) &&
                <MenuItem onClick={handleApprove}>
                    <ListItemIcon>
                        <ThumbUpOffAltIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Approve</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
